import { Controller } from "@hotwired/stimulus";
import mapboxgl, { Marker } from "mapbox-gl";
import { parse } from "wellknown";

export default class extends Controller {
  static values = {
    bounds: Array,
    recordingArea: String,
  };
  static targets = ["map", "marker"];

  connect() {
    mapboxgl.accessToken =
      "pk.eyJ1IjoibXJ3aWxsaWhvZyIsImEiOiJjbDI5YzRwZzkwMnNwM2NvNGY4aHh4eWR2In0.W4Eu3eTXf7XRC0e5K47zLw";
    this.initMap();
    this.initMarkers();
  }

  initMap() {
    const params = {
      container: this.mapTarget,
      style: "mapbox://styles/mapbox/outdoors-v11",
      attributionControl: false,
      logoPosition: "bottom-right",
      bounds: this.boundsValue,
    };

    const map = new mapboxgl.Map(params);
    map.scrollZoom.disable();
    map.addControl(new mapboxgl.NavigationControl(), "top-right");
    map.addControl(
      new mapboxgl.GeolocateControl({
        showUserLocation: false,
      }),
      "top-right"
    );
    map.on("load", this.initRecordingArea.bind(this));

    this.map = map;
  }

  initMarkers() {
    this.markerTargets.forEach((marker) => {
      const coords = marker.dataset.clubMapCoordsParam;
      const title = marker.dataset.clubMapTitleParam;
      const url = marker.dataset.clubMapUrlParam;
      const addBirdsUrl = marker.dataset.clubMapAddBirdsUrlParam;
      const color = marker.dataset.clubMapColorParam;

      if (coords !== "") {
        const coordsJson = JSON.parse(coords);
        const popup = new mapboxgl.Popup({})
          .setLngLat(coordsJson)
          .setHTML(
            `<div class="p-4">
            <h1 class="text-xl text-gray-900">
              ${title}
            </h1>
            <div class="flex gap-3 mt-1">
              <a href="${url}" class="text-teal-900 text-base outline-none">View</a>
              <a href="${addBirdsUrl}" class="text-teal-900 text-base outline-none">Add Records</a>
            </div>
          </div>
          `
          )
          .setMaxWidth("400px");

        new Marker({
          draggable: false,
          color: `#${color}`,
        })
          .setLngLat(coordsJson)
          .setPopup(popup)
          .addTo(this.map);
      }
    });
  }

  initRecordingArea() {
    const geom = this.recordingAreaValue;
    if (geom === "") {
      return;
    }
    const geoJson = parse(geom);

    this.map.addSource("recording-area", {
      type: "geojson",
      data: geoJson,
    });

    this.map.addLayer({
      id: "recording-area",
      type: "fill",
      source: "recording-area", // reference the data source
      layout: {},
      paint: {
        "fill-color": "#0080ff", // blue color fill
        "fill-opacity": 0.5,
      },
    });

    this.map.addLayer({
      id: "outline",
      type: "line",
      source: "recording-area",
      layout: {},
      paint: {
        "line-color": "#000",
        "line-width": 3,
      },
    });
  }
}
